import { App } from 'antd';
import { PermissionKey } from '@evimo/types/enums/permission-key';
import { AuthGuard } from '~/app/auth/guard/AuthGuard';
import { KmsDocumentDetailPageView } from './KmsDocumentDetailPageView';
import { useKmsDocumentDetail } from './hooks/useKmsDocumentDetail';

export function KmsDocumentDetailPageContainer() {
  const page = useKmsDocumentDetail();

  return (
    <AuthGuard requiredPermissions={[PermissionKey.DOCUMENTS_READ]}>
      <App>
        <KmsDocumentDetailPageView
          document={page.document}
          typeCandidates={page.typeCandidates}
          showTypeCandidates={page.showTypeCandidates}
          isLoading={page.isLoading}
          error={page.error}
          organizationId={page.organizationId}
          isSuperAdmin={page.isSuperAdmin}
          onBack={page.onBack}
        />
      </App>
    </AuthGuard>
  );
}
